/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import DatepickerField from "components/DatepickerField";
import FormField from "components/FormField";
import React from "react";
import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";

export default function Footer({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    managingUnitTaxId,
    managingUnit,
    notificationReceivingAgency,
    releaseDate,
    representative,
  } = formField;

  return (
    <Box mt={3}>
      <Box mb={4}>
        {/* <Typography component="label" variant="caption" fontWeight="bold" fontSize={14}>
          4 Thông tin đơn vị chủ quản (trường hợp tổ chức, cá nhân dùng hóa đơn của đơn vị chủ quản
          đặt in, tự in):
        </Typography> */}
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <FormField
            label={notificationReceivingAgency.label}
            name={notificationReceivingAgency.name}
            value={values.notificationReceivingAgency}
            error={errors.notificationReceivingAgency && touched.notificationReceivingAgency}
            success={
              values.notificationReceivingAgency?.toString().length > 0 &&
              !errors.notificationReceivingAgency
            }
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            label={representative.label}
            name={representative.name}
            value={values.representative}
            error={errors.representative && touched.representative}
            success={values.representative?.toString().length > 0 && !errors.representative}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            label={releaseDate.label}
            name={releaseDate.name}
            error={errors.releaseDate && touched.releaseDate}
            success={values.releaseDate?.toString().length > 0 && !errors.releaseDate}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
